function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ef7a18",
      fillOpacity: 1
    },
    d: "M 32.5 42.5 C 32.5 41.121094 31.378906 40 30 40 C 28.621094 40 27.5 41.121094 27.5 42.5 C 27.5 43.878906 28.621094 45 30 45 C 31.378906 45 32.5 43.878906 32.5 42.5 Z M 32.5 42.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#ef7a18",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 12 10 L 12 14 ",
    transform: "matrix(2.5,0,0,2.5,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#ef7a18",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 3.446875 18.10625 L 10.210938 4.578125 C 10.948438 3.103125 13.051563 3.103125 13.789062 4.578125 L 20.553125 18.10625 C 21.217188 19.435938 20.25 21 18.764063 21 L 5.235938 21 C 3.75 21 2.782813 19.435938 3.446875 18.10625 Z M 3.446875 18.10625 ",
    transform: "matrix(2.5,0,0,2.5,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.faa059561aa6bb06b16eb8b50749b6ba.svg";
export { ForwardRef as ReactComponent };